import api from "./index";

/**
 * Report API Service
 * Consolidated API calls for report data fetching
 * Uses the same axios instance as other APIs (baseURL: localhost:1337)
 */

// Generic API call helper
const apiCall = async (endpoint, params = {}, department = "All") => {
  try {
    const response = await api.get(`/report-stats/${endpoint}`, {
      params,
      headers: {
        department: department,
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${endpoint} report:`, error);
    throw error;
  }
};

/**
 * Get gender statistics report
 */
export const getGenderReport = (params, department) =>
  apiCall("gender", params, department);

/**
 * Get catheter statistics report (by month)
 */
export const getCatheterReport = (params, department) =>
  apiCall("catheter", params, department);

/**
 * Get consult papers by month report
 */
export const getConsultPapersReport = (params, department) =>
  apiCall("consult-papers", params, department);

/**
 * Get patient type statistics report
 */
export const getPatientTypeReport = (params, department) =>
  apiCall("patient-type", params, department);

/**
 * Get weight statistics report
 */
export const getWeightReport = (params, department) =>
  apiCall("weight", params, department);

/**
 * Get indications statistics report
 */
export const getIndicationsReport = (params, department) =>
  apiCall("indications", params, department);

/**
 * Get time paper to catheter statistics report
 */
export const getTimePaperToCatheterReport = (params, department) =>
  apiCall("time-paper-to-catheter", params, department);

/**
 * Get height statistics report
 */
export const getHeightReport = (params, department) =>
  apiCall("height", params, department);

/**
 * Get side cat statistics report
 */
export const getSideCatReport = (params, department) =>
  apiCall("side-cat", params, department);

/**
 * Get confirmation statistics report
 */
export const getConfirmationReport = (params, department) =>
  apiCall("confirmation", params, department);

/**
 * Get infection attempt statistics report
 */
export const getInfectionAttemptReport = (params, department) =>
  apiCall("infection-attempt", params, department);

/**
 * Get time attempt statistics report
 */
export const getTimeAttemptReport = (params, department) =>
  apiCall("time-attempt", params, department);

/**
 * Get success attempt statistics report
 */
export const getSucAttemptReport = (params, department) =>
  apiCall("suc-attempt", params, department);

/**
 * Get attempt by doctor statistics report
 */
export const getAttemptByDoctorReport = (params, department) =>
  apiCall("attempt-by-doctor", params, department);

/**
 * Get first attempt statistics report
 */
export const getFirstAttemptReport = (params, department) =>
  apiCall("first-attempt", params, department);

/**
 * Get average time statistics report
 */
export const getAvgTimeReport = (params, department) =>
  apiCall("avg-time", params, department);

/**
 * Get total day statistics report
 */
export const getTotalDayReport = (params, department) =>
  apiCall("total-day", params, department);

/**
 * Get reason by status statistics report
 */
export const getReasonByStatusReport = (params, department) =>
  apiCall("reason-by-status", params, department);

/**
 * Get reason statistics report
 */
export const getReasonReport = (params, department) =>
  apiCall("reason", params, department);

/**
 * Get complication statistics report
 */
export const getComplicationReport = (params, department) =>
  apiCall("complication", params, department);

/**
 * Get visit statistics report
 */
export const getVisitReport = (params, department) =>
  apiCall("visit", params, department);

/**
 * Get patency statistics report
 */
export const getPatencyReport = (params, department) =>
  apiCall("patency", params, department);

/**
 * Get rating statistics report
 */
export const getRatingReport = (params, department) =>
  apiCall("rating", params, department);

/**
 * Get department statistics report
 */
export const getDepartmentReport = (params, department) =>
  apiCall("department", params, department);

/**
 * Get label catheter statistics report
 */
export const getLabelCatheterReport = (params, department) =>
  apiCall("label-catheter", params, department);

/**
 * Get label catheter type statistics report
 */
export const getLabelCatheterTypeReport = (params, department) =>
  apiCall("label-catheter-type", params, department);

/**
 * Get catheter all statistics report
 */
export const getCatheterAllReport = (params, department) =>
  apiCall("catheter-all", params, department);

// Default export all APIs
const reportAPI = {
  getGenderReport,
  getCatheterReport,
  getConsultPapersReport,
  getPatientTypeReport,
  getWeightReport,
  getIndicationsReport,
  getTimePaperToCatheterReport,
  getHeightReport,
  getSideCatReport,
  getConfirmationReport,
  getInfectionAttemptReport,
  getTimeAttemptReport,
  getSucAttemptReport,
  getAttemptByDoctorReport,
  getFirstAttemptReport,
  getAvgTimeReport,
  getTotalDayReport,
  getReasonByStatusReport,
  getReasonReport,
  getComplicationReport,
  getVisitReport,
  getPatencyReport,
  getRatingReport,
  getDepartmentReport,
  getLabelCatheterReport,
  getLabelCatheterTypeReport,
  getCatheterAllReport,
};

export default reportAPI;
